import React from "react";
import { View, Text } from "@react-pdf/renderer";

const money = (n) => Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function PaymentSection({ S, data }) {
  return (
    <View style={[S.box, { marginTop: 10 }]}>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Text style={S.label}>Forma de Pago: {data.metodoPago || "—"}</Text>
        <Text style={S.bold}>
          TOTAL PAGADO {money(data.totalPagado)}
        </Text>
      </View>

      <View
        style={{
          marginTop: 6,
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Text style={S.muted}>Propina</Text>
        <Text>{money(data.tips)}</Text>
      </View>
    </View>
  );
}